import SatzMitDrops from './SatzMitDrops';

// Gruppiert ein flaches DB-Satz-Array nach Elternsatz und rendert es.
function SessionSaetze({ saetze, dropLabelPrefix = '' }) {
    const normaleSaetze = saetze.filter(s => !s.ist_dropsatz);
    const dropMap = saetze
        .filter(s => s.ist_dropsatz)
        .reduce((acc, ds) => {
            const key = String(ds.parent_satz_nummer);
            if (!acc[key]) acc[key] = [];
            acc[key].push(ds);
            return acc;
        }, {});

    return (
        <>
            {normaleSaetze.map((satz, idx) => (
                <SatzMitDrops
                    key={`satz-${idx}`}
                    satz={satz}
                    idx={idx}
                    drops={dropMap[String(satz.satz_nummer)] || []}
                    dropLabelPrefix={dropLabelPrefix}
                />
            ))}
        </>
    );
}

export default SessionSaetze;
